import React, { Component } from 'react';
import PropTypes from 'prop-types';
import createLogger from 'src/utils/logger';
import { Mixpanel } from '../../../Mixpanel';
import './Company.scss';

class Company extends Component {
  constructor() {
    super();
    this.logger = createLogger('Company');
    this.state = {
      news: '',
      newsErrors: [],
      sendingRequest: false,
      error: false,
    };
  }

  componentDidMount() {
    Mixpanel.track('About', {'Card' : 'Company'})
  }

  render() {    
    return (
      <div className="modal">
        <div>
          <h1>Мы - компания</h1>
          <p>
              Давайте поговорим, мы всегда рады, если компании хотят поддержать наше комьюнити и движение хакатонов. Готовы помочь по всем вопросам о хакатонах и стартапах. Пишите нам на почту partner@russianhackers.org.
          </p>
        </div>
      </div>
    );
  }
}

Company.propTypes = {
  closeModal: PropTypes.func.isRequired,
}

export default Company;



// WEBPACK FOOTER //
// ./src/components/Modal/About/Company/index.js